export const ERROR = 'project/common/error';
export const LOADING = 'project/common/loading';
export const LOADED = 'project/common/loaded';
export const APP_LANGUAGE = 'project/common/language';
export const ACTIVE_LANGUAGES = 'project/common/activeLanguages';
export const AVAILABLE_LANGUAGES = 'project/common/availableLanguages';
export const APPLICATION_DATA = 'project/app/applicationData';
export const APP_LOCALE = 'project/common/locale';